import { createSelector } from 'reselect';

import { formatTime } from '../../utils';
import { RootState } from '../models';

export const selectFormattedDuration = createSelector(
  (state:RootState) => state.video.duration, 
  (duration:number) => formatTime(duration, duration > 3600)
);